import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import {
  CssBaseline, CircularProgress, Container, Button, Grid,
  Chip, Box, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, IconButton, Collapse, Tooltip, Dialog,
  Autocomplete, TextField,
  DialogTitle, DialogContent, DialogActions, LinearProgress
} from "@mui/material"
import { withStyles } from "@mui/styles"
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import Api from "../../services/api"
import Api2Talk from "../../services/api2talk"
import ApiReports from "../../services/apireport"
import Pagination from '@mui/material/Pagination'
import * as calledsActions from '../../redux/actions/calleds'
import Footer from '../../components/footer'
import moment from "moment"
import { injectIntl } from 'react-intl'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import SpeedIcon from '@mui/icons-material/Speed'
import AssignmentIcon from '@mui/icons-material/Assignment'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import VisibilityIcon from '@mui/icons-material/Visibility'

const LOG_TYPE_OPTIONS = [
  { id: 1, name: 'Registro de Número' },
  { id: 2, name: 'Mensagem Recebida' },
  { id: 3, name: 'Mensagem Enviada' },
  { id: 4, name: 'Atualização de Status' },
  { id: 5, name: 'Criação de Template' },
  { id: 6, name: 'Atualização de Template' },
  { id: 7, name: 'Exclusão de Template' },
  { id: 8, name: 'Pesquisa de Satisfação' },
  { id: 9, name: 'Registro de Conta' },
  { id: 10, name: 'Requisição ao Provedor' },
  { id: 11, name: 'Webhook Recebido' },
  { id: 12, name: 'Erro no Envio' },
  { id: 13, name: 'Erro no Chat' },
  { id: 14, name: 'Chat criado sem canal' }
]

const SUCCESS_OPTIONS = [
  { id: 'true', name: 'Sucesso' },
  { id: 'false', name: 'Falha' }
]

// --- Styles ---
const kpiCardStyle = {
  minHeight: 130,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 12,
  position: 'relative',
  overflow: 'hidden',
  transition: 'box-shadow 0.3s ease',
  cursor: 'default',
  backgroundColor: '#fff',
  border: '1px solid #e0e0e0'
}

const kpiIconStyle = {
  fontSize: 40,
  opacity: 0.15,
  position: 'absolute',
  right: 16,
  top: 16,
  color: '#3F51B4'
}

const kpiValueStyle = {
  fontSize: 32,
  fontWeight: 700,
  lineHeight: 1.2,
  color: '#3F51B4'
}

const kpiLabelStyle = {
  fontSize: 13,
  fontWeight: 500,
  marginTop: 4,
  color: '#616161'
}

const tableHeaderStyle = {
  backgroundColor: '#3F51B4',
  '& th': {
    color: '#fff',
    fontWeight: 600,
    fontSize: 13,
    whiteSpace: 'nowrap'
  }
}

const horizontalScrollWrapperStyle = {
  width: '100%',
  maxWidth: '100%',
  overflowX: 'auto',
  overflowY: 'visible',
  paddingBottom: 8
}

const horizontalScrollInnerStyle = {
  minWidth: 1500
}

class MessagingChannelLogReport extends Component {

  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false
    this.isAdmGlobal = false

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item) => {
      if (item.role.roletype != 3)
        this.isClient = false
      if (item.role.roletype == 0 || item.role.roletype == 1)
        this.isAdm = true
      if (item.role.roletype == 0)
        this.isAdmGlobal = true
    })

    this.state = {
      dateStart: moment().subtract(1, 'months').format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      logTypeFilter: 0,
      successFilter: 0,
      registeredNumberFilter: null,
      registeredNumberSelectedOption: null,
      registeredNumbersOptions: [],
      loadingRegisteredNumbersOptions: false,
      chatIdFilter: '',
      errorCodeFilter: null,
      messageProviderIdFilter: null,

      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,

      // Main data
      logList: [],
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,

      // KPI summary
      summary: null,

      // Breakdown data
      byLogType: [],
      byErrorCode: [],
      byProvider: [],

      // Detail dialog
      detailOpen: false,
      detailItem: null,

      // Expanded rows
      expandedRows: {}
    }

    this.changeValues = this.changeValues.bind(this)
  }

  async componentDidMount() {
    await this.fetchRegisteredNumbersOptions()
  }

  getApiErrorMessage = (payload, fallbackMessage) => {
    if (payload && payload.response && payload.response.data && payload.response.data.errors && payload.response.data.errors[0])
      return payload.response.data.errors[0]

    if (payload && payload.data && payload.data.response && payload.data.response.data
      && payload.data.response.data.errors && payload.data.response.data.errors[0])
      return payload.data.response.data.errors[0]

    if (payload && payload.data && payload.data.errors && payload.data.errors[0])
      return payload.data.errors[0]

    return fallbackMessage || this.props.intl.formatMessage({ id: "process.error" })
  }

  notifyApiError = (payload, fallbackMessage) => {
    this.setState({
      openNotification: true,
      notificationVariant: "error",
      notificationMessage: this.getApiErrorMessage(payload, fallbackMessage)
    })

    if (payload)
      Api.kickoff(payload)
  }

  fetchRegisteredNumbersOptions = async () => {
    this.setState({ loadingRegisteredNumbersOptions: true })
    await Api2Talk.get('/registrationphonenumber/getallphoneactiveable')
      .then(result => {
        if (result.data.success && result.data.data) {
          const map = new Map()
          result.data.data.forEach(item => {
            if (item && item.id !== undefined && item.id !== null && item.phonenumber && !map.has(item.id)) {
              map.set(item.id, { id: item.id, name: item.phonenumber })
            }
          })
          this.setState({ registeredNumbersOptions: Array.from(map.values()) })
        } else {
          this.setState({ registeredNumbersOptions: [] })
          this.notifyApiError(result)
        }
      })
      .catch(err => {
        this.setState({ registeredNumbersOptions: [] })
        this.notifyApiError(err)
      })
      .finally(() => {
        this.setState({ loadingRegisteredNumbersOptions: false })
      })
  }

  changeValues = async (stateName, value) => {
    if (value && value.id !== undefined) {
      this.setState({ [stateName]: value.id })
    } else {
      this.setState({ [stateName]: value })
    }
  }

  handleRegisteredNumberChange = (event, value) => {
    this.setState({
      registeredNumberSelectedOption: value || null,
      registeredNumberFilter: value && value.id !== undefined && value.id !== null ? value.id : null
    })
  }

  handleOpenRegisteredNumbers = () => {
    if (!this.state.loadingRegisteredNumbersOptions && this.state.registeredNumbersOptions.length === 0)
      this.fetchRegisteredNumbersOptions()
  }

  getLogTypeName = (logTypeId) => {
    const logType = LOG_TYPE_OPTIONS.find(t => t.id === logTypeId)
    return logType ? logType.name : '-'
  }

  getRecipientValue = (item) => item.recipientid || item.recipient || '-'

  handleSubmit = async (e) => {
    e.preventDefault()
    this.setState({ loading: true })
    await this.fetchReport()
  }

  fetchReport = async () => {
    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (moment(dateStart).isAfter(moment(dateEnd))) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: "A data inicial deve ser menor que a data final.",
        loading: false
      })
      return
    }

    await Promise.all([
      this.fetchPaginate(dateStart, dateEnd, 1),
      this.fetchSummary(dateStart, dateEnd),
      this.fetchByLogType(dateStart, dateEnd),
      this.fetchByErrorCode(dateStart, dateEnd),
      this.fetchByProvider(dateStart, dateEnd)
    ])

    this.setState({ showGrid: true, loading: false })
  }

  buildFilterParams = (dateStart, dateEnd) => {
    let params = `startDate=${dateStart}&endDate=${dateEnd}`
    if (this.state.logTypeFilter && this.state.logTypeFilter !== 0)
      params += `&logType=${this.state.logTypeFilter}`
    if (this.state.successFilter && this.state.successFilter !== 0)
      params += `&success=${this.state.successFilter}`
    if (this.state.registeredNumberFilter)
      params += `&registeredPhoneNumberId=${encodeURIComponent(this.state.registeredNumberFilter)}`
    if (this.state.chatIdFilter && Number(this.state.chatIdFilter) > 0)
      params += `&chatId=${encodeURIComponent(this.state.chatIdFilter)}`
    if (this.state.errorCodeFilter)
      params += `&errorCode=${encodeURIComponent(this.state.errorCodeFilter)}`
    if (this.state.messageProviderIdFilter)
      params += `&messageProviderId=${encodeURIComponent(this.state.messageProviderIdFilter)}`
    return params
  }

  buildBreakdownFilterParams = (dateStart, dateEnd) => {
    let params = `startDate=${dateStart}&endDate=${dateEnd}`
    if (this.state.chatIdFilter && Number(this.state.chatIdFilter) > 0)
      params += `&chatId=${encodeURIComponent(this.state.chatIdFilter)}`
    return params
  }

  fetchPaginate = async (dateStart, dateEnd, page) => {
    const params = this.buildFilterParams(dateStart, dateEnd)
    await ApiReports.get(`/report/messaging-channel-log/paginate?${params}&page=${page}&pageSize=10`)
      .then(result => {
        if (result.data.success) {
          this.setState({
            logList: result.data.data,
            count: result.data.count,
            page: page
          })
          this.setPagination(result.data.count, page)
        } else {
          this.notifyApiError(result, "Erro ao buscar dados de  Logs de mensageria de provedores externos.")
        }
      })
      .catch(err => {
        this.notifyApiError(err, "Erro ao buscar dados de  Logs de mensageria de provedores externos.")
      })
  }

  fetchSummary = async (dateStart, dateEnd) => {
    const params = this.buildFilterParams(dateStart, dateEnd)
    await ApiReports.get(`/report/messaging-channel-log/summary?${params}`)
      .then(result => {
        if (result.data.success) {
          this.setState({ summary: result.data.data })
        } else {
          this.notifyApiError(result)
        }
      })
      .catch(err => {
        this.notifyApiError(err)
      })
  }

  fetchByLogType = async (dateStart, dateEnd) => {
    await ApiReports.get(`/report/messaging-channel-log/by-log-type?startDate=${dateStart}&endDate=${dateEnd}`)
      .then(result => {
        if (result.data.success) {
          this.setState({ byLogType: result.data.data })
        } else {
          this.notifyApiError(result)
        }
      })
      .catch(err => {
        this.notifyApiError(err)
      })
  }

  fetchByErrorCode = async (dateStart, dateEnd) => {
    const params = this.buildBreakdownFilterParams(dateStart, dateEnd)
    await ApiReports.get(`/report/messaging-channel-log/by-error-code?${params}`)
      .then(result => {
        if (result.data.success) {
          this.setState({ byErrorCode: result.data.data })
        } else {
          this.notifyApiError(result)
        }
      })
      .catch(err => {
        this.notifyApiError(err)
      })
  }

  fetchByProvider = async (dateStart, dateEnd) => {
    const params = this.buildBreakdownFilterParams(dateStart, dateEnd)
    await ApiReports.get(`/report/messaging-channel-log/by-provider?${params}`)
      .then(result => {
        if (result.data.success) {
          this.setState({ byProvider: result.data.data })
        } else {
          this.notifyApiError(result)
        }
      })
      .catch(err => {
        this.notifyApiError(err)
      })
  }

  onChangePaginate = (e, page) => {
    this.setState({ loading: true })
    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')
    this.fetchPaginate(dateStart, dateEnd, page).then(() => {
      this.setState({ loading: false })
    })
  }

  refreshInteractiveResults = async () => {
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (moment(dateStart).isAfter(moment(dateEnd))) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: "A data inicial deve ser menor que a data final.",
        loading: false
      })
      return
    }

    await Promise.all([
      this.fetchPaginate(dateStart, dateEnd, 1),
      this.fetchSummary(dateStart, dateEnd)
    ])

    this.setState({ loading: false })
  }

  toggleInteractiveFilter = (stateName, value) => {
    if (value === undefined || value === null || value === '')
      return

    this.setState(prevState => ({
      [stateName]: prevState[stateName] === value ? null : value,
      loading: true
    }), this.refreshInteractiveResults)
  }

  handleInteractiveFilterKeyDown = (event, stateName, value) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      this.toggleInteractiveFilter(stateName, value)
    }
  }

  handleChatIdChange = (event) => {
    const value = event.target.value
    if (value === '' || /^\d+$/.test(value))
      this.setState({ chatIdFilter: value })
  }

  setPagination = (count, page) => {
    let totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        this.setState({
          pageStart: 1,
          pageEnd: count < 10 ? count : 10
        })
      } else {
        let pageStart = ((page - 1) * 10) + 1
        this.setState({
          pageStart: pageStart,
          pageEnd: count >= page * 10 ? page * 10 : count
        })
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0 })
    }
  }

  toggleRow = (id) => {
    this.setState(prev => ({
      expandedRows: { ...prev.expandedRows, [id]: !prev.expandedRows[id] }
    }))
  }

  openDetail = (item) => {
    this.setState({ detailOpen: true, detailItem: item })
  }

  closeDetail = () => {
    this.setState({ detailOpen: false, detailItem: null })
  }

  exportExcel = async () => {
    this.setState({ loading: true })
    try {
      const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
      const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

      if (moment(dateStart).isAfter(moment(dateEnd))) {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: "A data inicial deve ser menor que a data final.",
          loading: false
        })
        return
      }

      let successValue = null
      if (this.state.successFilter === 'true')
        successValue = true
      else if (this.state.successFilter === 'false')
        successValue = false

      const payload = {
        DateStart: dateStart,
        DateEnd: dateEnd,
        LogType: this.state.logTypeFilter && this.state.logTypeFilter !== 0 ? this.state.logTypeFilter : null,
        Success: successValue,
        MessageProviderId: this.state.messageProviderIdFilter,
        RegisteredPhoneNumberId: this.state.registeredNumberFilter,
        ChatId: this.state.chatIdFilter && Number(this.state.chatIdFilter) > 0 ? Number(this.state.chatIdFilter) : null,
        ErrorCode: this.state.errorCodeFilter
      }

      const response = await ApiReports.post('/report/messaging-channel-log/excell/new', payload)
      if (response.data && response.data.success) {
        this.setState({
          openNotification: true,
          notificationVariant: "success",
          notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")"
        })
      } else {
        this.notifyApiError(response)
      }
    } catch (error) {
      this.notifyApiError(error)
    }
    this.setState({ loading: false })
  }

  closeNotification = () => {
    this.setState({ openNotification: false })
  }

  renderKPIs() {
    const { summary } = this.state
    if (!summary) return null

    const successRateColor = summary.successrate >= 90 ? '#059669' : summary.successrate >= 70 ? '#d97706' : '#dc2626'

    const cards = [
      {
        label: 'Total de Logs',
        value: summary.totallogs,
        icon: <AssignmentIcon style={kpiIconStyle} />,
        tooltip: 'Quantidade total de  Logs de mensageria de provedores externos registrados no período selecionado, independente de sucesso ou falha.'
      },
      {
        label: 'Taxa de Sucesso',
        value: `${summary.successrate}%`,
        valueColor: successRateColor,
        icon: <TrendingUpIcon style={kpiIconStyle} />,
        tooltip: 'Percentual de logs que foram concluídos com sucesso. Calculada como: (logs com sucesso ÷ total de logs) × 100. Verde (>=90%): excelente. Amarelo (70%-89%): atenção. Vermelho (<70%): crítico.'
      },
      {
        label: 'Sucesso / Falha',
        value: `${summary.successcount} / ${summary.failurecount}`,
        icon: <CheckCircleIcon style={kpiIconStyle} />,
        tooltip: 'Quantidade absoluta de logs com sucesso e com falha no período.'
      }
    ]

    return (
      <Grid container spacing={2} style={{ marginBottom: 20, marginTop: 10 }}>
        {cards.map((card, idx) => (
          <Grid item xs={12} sm={6} md={true} key={idx}>
            <Tooltip title={card.tooltip} arrow placement="top">
              <Paper elevation={1} style={kpiCardStyle}>
                {card.icon}
                <Typography style={{ ...kpiValueStyle, ...(card.valueColor ? { color: card.valueColor } : {}) }}>{card.value}</Typography>
                <Typography style={kpiLabelStyle}>{card.label}</Typography>
              </Paper>
            </Tooltip>
          </Grid>
        ))}
      </Grid>
    )
  }

  renderLogTypeBreakdown() {
    const { byLogType } = this.state
    if (!byLogType || byLogType.length === 0) return null

    const total = byLogType.reduce((sum, s) => sum + s.count, 0)

    return (
      <Grid container spacing={2} style={{ marginBottom: 20 }}>
        <Grid item xs={12}>
          <Paper elevation={2} style={{ borderRadius: 12 }}>
            <Box style={{ padding: '16px 20px', backgroundColor: '#3F51B4', color: '#fff' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
                Distribuição por Tipo de Log
              </Typography>
            </Box>
            <Box style={{ padding: 20 }}>
              {byLogType.map((item, idx) => {
                const pct = total > 0 ? ((item.count / total) * 100).toFixed(1) : 0
                const successPct = item.count > 0 ? ((item.successcount / item.count) * 100).toFixed(1) : 0
                return (
                  <Box key={idx} style={{ marginBottom: idx < byLogType.length - 1 ? 16 : 0 }}>
                    <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                      <Typography style={{ fontWeight: 600, fontSize: 14 }}>
                        {this.getLogTypeName(item.logtype)}
                      </Typography>
                      <Box style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                        <Chip size="small" label={`${item.count} (${pct}%)`} style={{ fontWeight: 600 }} />
                        <Chip size="small" label={`Sucesso: ${successPct}%`}
                          style={{
                            backgroundColor: successPct >= 90 ? '#dcfce7' : successPct >= 70 ? '#fef3c7' : '#fecaca',
                            color: successPct >= 90 ? '#166534' : successPct >= 70 ? '#92400e' : '#991b1b',
                            fontWeight: 600
                          }} />
                      </Box>
                    </Box>
                    <LinearProgress
                      variant="determinate"
                      value={parseFloat(pct)}
                      style={{ height: 8, borderRadius: 4, backgroundColor: '#e5e7eb' }}
                      sx={{ '& .MuiLinearProgress-bar': { borderRadius: 4, backgroundColor: '#66BB6A' } }}
                    />
                  </Box>
                )
              })}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    )
  }

  renderErrorCodeBreakdown() {
    const { byErrorCode } = this.state
    if (!byErrorCode || byErrorCode.length === 0) return null

    // Top 10 error codes
    const topErrors = byErrorCode.slice(0, 10)
    return (
      <Grid container spacing={2} style={{ marginBottom: 20 }}>
        <Grid item xs={12}>
          <Paper elevation={2} style={{ borderRadius: 12 }}>
            <Box style={{ padding: '16px 20px', backgroundColor: '#3F51B4', color: '#fff' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
                Top 10 Códigos de Erro
              </Typography>
            </Box>
            <TableContainer style={{ width: '100%', maxWidth: '100%', overflowX: 'auto', display: 'block' }}>
              <Table size="small" style={{ minWidth: 720 }}>
                <TableHead>
                  <TableRow style={{ backgroundColor: '#3F51B4' }}>
                    <TableCell style={{ fontWeight: 700, width: 50, color: '#fff', whiteSpace: 'nowrap' }}>#</TableCell>
                    <TableCell style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Código de erro</TableCell>
                    <TableCell style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }} align="center">Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {topErrors.map((error, idx) => {
                    const canSelect = !!error.errorcode
                    const isSelected = this.state.errorCodeFilter === error.errorcode
                    return (
                      <TableRow
                        key={`${error.errorcode || 'empty'}-${idx}`}
                        hover={canSelect}
                        selected={isSelected}
                        tabIndex={canSelect ? 0 : undefined}
                        aria-pressed={canSelect ? isSelected : undefined}
                        title={canSelect ? (isSelected ? 'Clique para remover o filtro' : 'Clique para filtrar por este código de erro') : undefined}
                        onClick={canSelect ? () => this.toggleInteractiveFilter('errorCodeFilter', error.errorcode) : undefined}
                        onKeyDown={canSelect ? event => this.handleInteractiveFilterKeyDown(event, 'errorCodeFilter', error.errorcode) : undefined}
                        style={{
                          backgroundColor: isSelected ? '#e8eaf6' : idx % 2 === 0 ? '#fff' : '#f8fafc',
                          cursor: canSelect ? 'pointer' : 'default'
                        }}>
                        <TableCell>
                          <Box style={{
                            width: 28, height: 28, borderRadius: '50%',
                            backgroundColor: idx < 3 ? '#dc2626' : '#94a3b8',
                            color: '#fff', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', fontWeight: 700, fontSize: 12
                          }}>
                            {idx + 1}
                          </Box>
                        </TableCell>
                        <TableCell style={{ fontWeight: 500 }}>{error.errorcode || 'N/A'}</TableCell>
                        <TableCell align="center" style={{ fontWeight: 700, fontSize: 16 }}>{error.count}</TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    )
  }

  renderProviderBreakdown() {
    const { byProvider } = this.state
    if (!byProvider || byProvider.length === 0) return null

    const total = byProvider.reduce((sum, p) => sum + p.count, 0)

    return (
      <Grid container spacing={2} style={{ marginBottom: 20 }}>
        <Grid item xs={12}>
          <Paper elevation={2} style={{ borderRadius: 12 }}>
            <Box style={{ padding: '16px 20px', backgroundColor: '#3F51B4', color: '#fff' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
                Estatísticas por Provedor
              </Typography>
            </Box>
            <TableContainer style={{ width: '100%', maxWidth: '100%', overflowX: 'auto', display: 'block' }}>
              <Table size="small" style={{ minWidth: 920 }}>
                <TableHead>
                  <TableRow style={{ backgroundColor: '#3F51B4' }}>
                    <TableCell style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>Provedor</TableCell>
                    <TableCell style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }} align="center">Total</TableCell>
                    <TableCell style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }} align="center">Sucesso</TableCell>
                    <TableCell style={{ fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }} align="center">Falha</TableCell>
                    {/* <TableCell style={{ fontWeight: 700, minWidth: 200, color: '#fff' }}>Taxa de Sucesso</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {byProvider.map((provider, idx) => {
                    const successPct = provider.count > 0 ? ((provider.successcount / provider.count) * 100).toFixed(1) : 0
                    const canSelect = provider.messageproviderid !== undefined && provider.messageproviderid !== null
                    const isSelected = canSelect && this.state.messageProviderIdFilter === provider.messageproviderid
                    return (
                      <TableRow
                        key={canSelect ? provider.messageproviderid : `empty-${idx}`}
                        hover={canSelect}
                        selected={isSelected}
                        tabIndex={canSelect ? 0 : undefined}
                        aria-pressed={canSelect ? isSelected : undefined}
                        title={canSelect ? (isSelected ? 'Clique para remover o filtro' : 'Clique para filtrar por este provedor') : undefined}
                        onClick={canSelect ? () => this.toggleInteractiveFilter('messageProviderIdFilter', provider.messageproviderid) : undefined}
                        onKeyDown={canSelect ? event => this.handleInteractiveFilterKeyDown(event, 'messageProviderIdFilter', provider.messageproviderid) : undefined}
                        style={{
                          backgroundColor: isSelected ? '#e8eaf6' : idx % 2 === 0 ? '#fff' : '#f8fafc',
                          cursor: canSelect ? 'pointer' : 'default'
                        }}>
                        <TableCell style={{ fontWeight: 600 }}>{provider.messageprovidername || 'N/A'}</TableCell>
                        <TableCell align="center" style={{ fontWeight: 700, fontSize: 16 }}>{provider.count}</TableCell>
                        <TableCell align="center">
                          <Chip size="small" label={provider.successcount}
                            style={{ backgroundColor: '#dcfce7', color: '#166534', fontWeight: 600 }} />
                        </TableCell>
                        <TableCell align="center">
                          <Chip size="small" label={provider.failurecount}
                            style={{ backgroundColor: '#fecaca', color: '#991b1b', fontWeight: 600 }} />
                        </TableCell>
                        {/* <TableCell>
                          <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Box style={{ flex: 1, height: 8, borderRadius: 4, backgroundColor: '#e5e7eb', overflow: 'hidden' }}>
                              <Box style={{
                                width: `${successPct}%`,
                                height: '100%',
                                borderRadius: 4,
                                backgroundColor: successPct >= 90 ? '#059669' : successPct >= 70 ? '#d97706' : '#dc2626',
                                transition: 'width 0.5s ease'
                              }} />
                            </Box>
                            <Typography variant="caption" style={{ fontWeight: 600, minWidth: 45 }}>{successPct}%</Typography>
                          </Box>
                        </TableCell> */}
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    )
  }

  renderDetailDialog() {
    const { detailOpen, detailItem } = this.state
    if (!detailItem) return null

    return (
      <Dialog open={detailOpen} onClose={this.closeDetail} maxWidth="md" fullWidth>
        <DialogTitle style={{ backgroundColor: '#3F51B4', color: '#fff', fontWeight: 600 }}>
          Detalhe do Log #{detailItem.id}
        </DialogTitle>
        <DialogContent style={{ paddingTop: 20 }}>
          <Grid container spacing={2}>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">ID</Typography>
              <Typography style={{ fontWeight: 600 }}>#{detailItem.id}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">Data</Typography>
              <Typography style={{ fontWeight: 600 }}>{moment(detailItem.createdat).format('DD/MM/YYYY HH:mm:ss')}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">Tipo de Log</Typography>
              <Typography style={{ fontWeight: 600 }}>{this.getLogTypeName(detailItem.logtype)}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant="caption" color="textSecondary">Status</Typography>
              {detailItem.success
                ? <Chip size="small" icon={<CheckCircleIcon />} label="Sucesso" style={{ backgroundColor: '#dcfce7', color: '#166534' }} />
                : <Chip size="small" icon={<CancelIcon />} label="Falha" style={{ backgroundColor: '#fecaca', color: '#991b1b' }} />
              }
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Provedor</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.messageprovidername || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">ID do Usuário</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.userid || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Código de erro</Typography>
              <Typography style={{ fontWeight: 500, color: detailItem.errorcode ? '#dc2626' : '#666' }}>
                {detailItem.errorcode || '-'}
              </Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Título do Erro</Typography>
              <Typography style={{ fontWeight: 500, color: detailItem.errortitle ? '#dc2626' : '#666' }}>
                {detailItem.errortitle || '-'}
              </Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Origem do Evento</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.eventorigin || '-'}</Typography>
            </Grid>
            {detailItem.message && (
              <Grid item xs={12}>
                <Typography variant="caption" color="textSecondary">Mensagem de Erro</Typography>
                <Typography style={{ fontWeight: 500, color: '#dc2626', whiteSpace: 'pre-wrap', backgroundColor: '#fef2f2', padding: 12, borderRadius: 8, fontSize: 13 }}>
                  {detailItem.message}
                </Typography>
              </Grid>
            )}
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Telefone</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.phonenumber || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Destinatário</Typography>
              <Typography style={{ fontWeight: 500 }}>{this.getRecipientValue(detailItem)}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">ID Externo</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.externalid || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Status</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.statusdescription || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Fingerprint</Typography>
              <Typography style={{ fontWeight: 500, wordBreak: 'break-all' }}>{detailItem.eventfingerprint || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Phone Number Id</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.phonenumberid || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Produto Mensageria</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.messagingproduct || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Conversation Id</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.conversationid || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Endpoint</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.endpointpath || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">ID Referência</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.referenceid || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Tabela Referência</Typography>
              <Typography style={{ fontWeight: 500 }}>{detailItem.referencetable || '-'}</Typography>
            </Grid>
            <Grid item xs={6} md={4}>
              <Typography variant="caption" color="textSecondary">Chat / Mensagem / Template</Typography>
              <Typography style={{ fontWeight: 500 }}>
                {(detailItem.chatid || '-') + ' / ' + (detailItem.chatmessageid || '-') + ' / ' + (detailItem.templatemessageid || '-')}
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeDetail} variant="contained" style={{ backgroundColor: '#3F51B4', color: '#fff' }}>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  renderMainTable() {
    const { logList } = this.state

    return (
         <Paper elevation={2} style={{ borderRadius: 12, marginBottom: 20 }}>
      {/* Header separado para não herdar overflow: hidden da tabela */}
      <Box style={{
        padding: '16px 20px',
        backgroundColor: '#3F51B4',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: '12px 12px 0 0'   // ← apenas topo arredondado
      }}>
        <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
          Log de Mensageria
        </Typography>
        <Typography variant="caption" style={{ opacity: 0.8, color: 'inherit' }}>
          {this.state.count} registro(s)
        </Typography>
      </Box>

      {/* 2. Garantir que o TableContainer tenha overflowX explícito */}
       <TableContainer style={{ width: '100%', maxWidth: '100%', overflowX: 'auto', display: 'block' }}>
         <Table size="small" style={{ minWidth: 1400 }}>
            <TableHead>
              <TableRow style={{ backgroundColor: '#3F51B4' }}>
                <TableCell style={{ fontWeight: 700, width: 30, color: '#fff' }} />
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Id</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Data</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Tipo de Log</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Provedor</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="center">Status</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Código de erro</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Status Desc.</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Origem</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Telefone</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>ID Externo</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logList.map((item, idx) => (
                <React.Fragment key={item.id}>
                  <TableRow hover style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                    <TableCell>
                      <IconButton size="small" onClick={() => this.toggleRow(item.id)}>
                        {this.state.expandedRows[item.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      {item.id}
                    </TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                      {moment(item.createdat).format('DD/MM/YYYY HH:mm:ss')}
                    </TableCell>
                    <TableCell>
                      <Chip size="small" label={this.getLogTypeName(item.logtype)}
                        variant="outlined" style={{ fontWeight: 500 }} />
                    </TableCell>
                    <TableCell style={{ fontWeight: 500 }}>{item.messageprovidername || '-'}</TableCell>
                    <TableCell align="center">
                      {item.success
                        ? <Chip size="small" icon={<CheckCircleIcon style={{ fontSize: 16 }} />} label="OK"
                            style={{ backgroundColor: '#dcfce7', color: '#166534', fontWeight: 600 }} />
                        : <Chip size="small" icon={<CancelIcon style={{ fontSize: 16 }} />} label="Falha"
                            style={{ backgroundColor: '#fecaca', color: '#991b1b', fontWeight: 600 }} />
                      }
                    </TableCell>
                    <TableCell style={{ color: item.errorcode ? '#dc2626' : '#666', fontWeight: item.errorcode ? 600 : 400 }}>
                      {item.errorcode || '-'}
                    </TableCell>
                    <TableCell style={{ fontWeight: 500 }}>{item.statusdescription || '-'}</TableCell>
                    <TableCell style={{ fontWeight: 500 }}>{item.eventorigin || '-'}</TableCell>
                    <TableCell style={{ fontWeight: 500 }}>{item.phonenumber || '-'}</TableCell>
                    <TableCell style={{ fontWeight: 500, fontSize: 12 }}>{item.externalid || '-'}</TableCell>
                    <TableCell align="center">
                      <Tooltip title="Ver detalhes completos">
                        <IconButton size="small" onClick={() => this.openDetail(item)}>
                          <VisibilityIcon style={{ fontSize: 20, color: '#059669' }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: this.state.expandedRows[item.id] ? undefined : 'none' }} colSpan={12}>
                      <Collapse in={this.state.expandedRows[item.id]} timeout="auto" unmountOnExit>
                        <Box style={{ margin: '12px 0', padding: 16, backgroundColor: '#f8fafc', borderRadius: 8 }}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                              <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Destinatário</Typography>
                              <Typography style={{ fontSize: 13 }}>{this.getRecipientValue(item)}</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>ID Referência / Tabela</Typography>
                              <Typography style={{ fontSize: 13 }}>{item.referenceid || '-'} / {item.referencetable || '-'}</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Origem / Fingerprint</Typography>
                              <Typography style={{ fontSize: 13 }}>{item.eventorigin || '-'} / {item.eventfingerprint || '-'}</Typography>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Status / Produto</Typography>
                              <Typography style={{ fontSize: 13 }}>{item.statusdescription || '-'} / {item.messagingproduct || '-'}</Typography>
                            </Grid>
                            {item.message && (
                              <Grid item xs={12}>
                                <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>Mensagem de Erro</Typography>
                                <Typography style={{ fontSize: 13, color: '#dc2626', whiteSpace: 'pre-wrap' }}>{item.message}</Typography>
                              </Grid>
                            )}
                          </Grid>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
              {logList.length === 0 && (
                <TableRow>
                  <TableCell colSpan={12} align="center" style={{ padding: 40, color: '#94a3b8' }}>
                    Nenhum log encontrado para o período selecionado.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    )
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props

    if (!this.isAdmGlobal) {
      var l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    if (Api == null) {
      var l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
          style={{ minWidth: 0 }}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', minWidth: 0, paddingLeft: 0, paddingRight: 0, marginLeft: 0, overflowX: 'visible', paddingBottom: 96 }}>
            <CssBaseline />

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card>
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      Relatório de Logs de mensageria de provedores externos
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <form name='messagingChannelLogReportForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>Filtros</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container style={{ marginBottom: 20 }} spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker label="Data Inicial" name='dateStart' stateName='dateStart'
                        changeDate={this.changeValues} currentDate={this.state.dateStart} fullWidth={true} required />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker label="Data Final" name='dateEnd' stateName='dateEnd'
                        changeDate={this.changeValues} currentDate={this.state.dateEnd} fullWidth={true} required />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete label="Tipo de Log" options={LOG_TYPE_OPTIONS}
                        stateName='logTypeFilter' changeSelect={this.changeValues} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete label="Resultado" options={SUCCESS_OPTIONS}
                        stateName='successFilter' changeSelect={this.changeValues} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Autocomplete
                        options={this.state.registeredNumbersOptions}
                        value={this.state.registeredNumberSelectedOption}
                        onChange={this.handleRegisteredNumberChange}
                        onOpen={this.handleOpenRegisteredNumbers}
                        getOptionLabel={(option) => option && option.name ? option.name : ''}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        loading={this.state.loadingRegisteredNumbersOptions}
                        noOptionsText="Nenhum número registrado"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Números registrados"
                            variant="outlined"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        fullWidth
                        label="ID do Chat"
                        type="number"
                        variant="outlined"
                        value={this.state.chatIdFilter}
                        onChange={this.handleChatIdChange}
                        inputProps={{ min: 1, step: 1 }}
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Grid container style={{ marginBottom: 10 }}>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button type='submit' fullWidth variant='contained' color='secondary'>
                    Filtrar
                  </Button>
                </Grid>
                {this.state.showGrid && (
                  <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                    <Button fullWidth variant='contained' color='secondary' onClick={this.exportExcel}>
                      Exportar Excel
                    </Button>
                  </Grid>
                )}
              </Grid>
            </form>

            {this.state.showGrid && (
              <Box style={horizontalScrollWrapperStyle}>
                <Box style={horizontalScrollInnerStyle}>
                  {this.renderKPIs()}
                  {/*this.renderLogTypeBreakdown()*/}
                  {this.renderErrorCodeBreakdown()}
                  {this.renderProviderBreakdown()}
                  {this.renderMainTable()}

                  <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                    <Grid item xs={12} md={3}>
                      <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                      {this.state.pageStart} a {this.state.pageEnd} de {this.state.count} registro(s)
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}

            {this.renderDetailDialog()}

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

MessagingChannelLogReport.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(MessagingChannelLogReport)))
